import { Card } from '@/components/common'

interface StatCardProps {
  label: string
  value: number
  color: 'green' | 'blue' | 'orange' | 'purple' | 'indigo' | 'red'
}

const colorMap = {
  green: { bg: 'bg-green-50', valueText: 'text-green-700' },
  blue: { bg: 'bg-blue-50', valueText: 'text-blue-700' },
  orange: { bg: 'bg-orange-50', valueText: 'text-orange-700' },
  purple: { bg: 'bg-purple-50', valueText: 'text-purple-700' },
  indigo: { bg: 'bg-indigo-50', valueText: 'text-indigo-700' },
  red: { bg: 'bg-red-50', valueText: 'text-red-700' },
}

export function StatCard({ label, value, color }: StatCardProps) {
  const colors = colorMap[color]
  return (
    <Card>
      <div className={`p-4 ${colors.bg}`}>
        <p className="text-sm text-gray-600">{label}</p>
        <p className={`text-2xl font-bold ${colors.valueText}`}>
          {value.toLocaleString('de-CH')}
        </p>
      </div>
    </Card>
  )
}
